import { RouteObject } from 'react-router-dom';
import RootRoute from './routes/Root';
import IndexRoute from '@/website/routes/_index/Route';
import ErrorBoundary from '@/common/components/ErrorBoundary.tsx';
import ProvidersRoute, {
  loader as providersLoader,
} from '@/website/routes/providers/Route';
import ProviderRoute, {
  loader as providerLoader,
} from '@/website/routes/provider/Route';
import FAQsRoute from '@/website/routes/faqs/Route';
import AboutRoute from '@/website/routes/about/Route';
import CareersRoute from '@/website/routes/careers/Route';
import PatientReferralRoute, {
  action as patientReferralAction,
} from '@/website/routes/patient-referral/Route';

export const createWebsiteRoutes = (): RouteObject[] => [
  {
    id: 'root',
    element: <RootRoute />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        id: 'index',
        index: true,
        element: <IndexRoute />,
      },
      {
        id: 'providers',
        path: '/providers',
        element: <ProvidersRoute />,
        loader: providersLoader,
      },
      {
        id: 'provider',
        path: '/providers/:providerId',
        element: <ProviderRoute />,
        loader: providerLoader,
      },
      {
        id: 'faqs',
        path: '/faqs',
        element: <FAQsRoute />,
      },
      {
        id: 'about',
        path: '/about',
        element: <AboutRoute />,
      },
      {
        id: 'careers',
        path: '/careers',
        element: <CareersRoute />,
      },
      {
        id: 'patient-referral',
        path: '/patient-referral',
        element: <PatientReferralRoute />,
        action: patientReferralAction,
      },
    ],
  },
];
